export const blank_line = `\u2003\u2003\u2003\u2003\u2003\u2003\u2003\u2003`;


// WEBPACK FOOTER //
// ./src/model/Const.js